// requires parity with backend/utils/countryCorrections
// used to lookup custom country name changes
// { currentNameInData: customName}
const countryCorrections = {
  'Taiwan, Province of China': 'Taiwan',
};

export default countryCorrections;
